<template>
  <!-- SaaS maintenance notice from the status poll: { en, ar } in the current language -->
  <v-alert type="warning" text dense dismissible icon="mdi-wrench-outline" class="maintenance-banner mb-3" @input="onInput">
    <span class="maintenance-text">{{ text }}</span>
  </v-alert>
</template>

<script>
import { localizedText } from "../../utils/saas-catalog";

export default {
  name: "MaintenanceBanner",
  props: {
    message: {
      type: [Object, String],
      default: null,
    },
  },
  computed: {
    text() {
      return localizedText(this.message, this.$i18n.locale) || this.$t("saasPlan.maintenanceDefault");
    },
  },
  methods: {
    onInput(value) {
      if (!value) this.$emit("dismiss");
    },
  },
};
</script>

<style scoped>
.maintenance-text {
  white-space: pre-line;
}
</style>
